import axios from '../axios-orders';

/*export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));
    if (user && user.token) {
       // return { 'Authorization': 'Bearer ' + user.token };    
      }
      return request;
    } else {
        return {};
    }
}*/
export function authHeader()  {
  //console.log("llego a auth");
  axios.interceptors.request.use((request) => {
    //console.log('axios-inteceptor');
    let user = JSON.parse(localStorage.getItem('access_token'));
     //const { token } = store.state.auth;
      const hasAuthHeader = request.headers.Authorization;
      //if (token && token.accessToken && !hasAuthHeader) {
        if(user && !hasAuthHeader){
          request.headers.common.Authorization = `Bearer ${user.access_token}`;
          request.headers.common['Content-Type'] = 'application/json';
        }        
      return request;
    });
  }
  

